import { Controller } from "@hotwired/stimulus"

// Staggers animation of child elements when parent enters viewport
// Usage: data-controller="stagger"
//        data-stagger-delay-value="100"
//        data-stagger-class-value="nd-animate-fade-up"
//        data-stagger-selector-value="> *" (optional, defaults to direct children)
export default class extends Controller {
  static values = {
    delay: { type: Number, default: 100 },
    class: { type: String, default: "nd-animate-fade-up" },
    threshold: { type: Number, default: 0.1 },
    selector: { type: String, default: "" }
  }

  connect() {
    // Respect reduced motion preference
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.getChildren().forEach(child => {
        child.classList.remove("nd-animate-hidden")
        child.classList.add(this.classValue)
      })
      return
    }

    this.observer = new IntersectionObserver(
      this.handleIntersect.bind(this),
      {
        threshold: this.thresholdValue,
        rootMargin: "0px 0px -30px 0px"
      }
    )
    
    this.observer.observe(this.element)
  }

  handleIntersect(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.animateChildren()
        this.observer.disconnect()
      }
    })
  }

  getChildren() {
    if (this.selectorValue) {
      return this.element.querySelectorAll(this.selectorValue)
    }
    return this.element.children
  }

  animateChildren() {
    const children = this.getChildren()
    Array.from(children).forEach((child, index) => {
      setTimeout(() => {
        child.classList.remove("nd-animate-hidden")
        child.classList.add(this.classValue)
      }, index * this.delayValue)
    })
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}
